import { Injectable } from '@angular/core';
import { RequestService } from './request.service';
import { Observable, throwError } from 'rxjs';
import { HttpEvent } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { Prescription } from '../models/prescription.model';
import { PrescriptionGeneratorService } from '../enums/prescription-generator-service.enum';
import { COUNTRY_CODE } from '../consts/country-code.const';
import { Call } from '../models/call.model';
import { DiagnosisService } from './diagnosis.service';
import { PatientService } from './patient.service';
import { environment } from 'src/environments/environment';

export type PrescriptionGenerator = {
  service: PrescriptionGeneratorService;
  url?: string;
  manualSend?: boolean; // Indicates if the prescription needs to be sent to the patient by LAD
};

const { PRESCRYPTO, MEMED } = PrescriptionGeneratorService;

@Injectable({
  providedIn: 'root'
})
export class PrescriptionService {
  constructor(
    private requestService: RequestService,
    private diagnosisService: DiagnosisService,
    private patientService: PatientService
  ) {}

  uploadExternal(callId: string, formData: FormData): Observable<HttpEvent<Prescription>> {
    return this.requestService
      .postObservable(`/prescription/call/${callId}/external`, formData, {
        reportProgress: true,
        observe: 'events'
      })
      .pipe(
        catchError((error) => {
          const err = typeof error === 'function' ? error() : error;
          return throwError(err);
        })
      );
  }

  getGenerator(call: Call): PrescriptionGenerator | null {
    if (call.provider.country?.countryCode === COUNTRY_CODE.MEXICO) {
      return { service: PRESCRYPTO, url: this.getPrescryptoUrl(call) };
    }

    if (call.provider.country?.countryCode === COUNTRY_CODE.BRAZIL) {
      return { service: MEMED, manualSend: true };
    }
    return null;
  }

  getPrescryptoUrl(call: Call): string {
    const prescryptoToken = encodeURIComponent(call.doctor.prescryptoToken);
    const diagnosis = encodeURIComponent(this.diagnosisService.getByCode(call.diagnosis?.diagnosis) || '');
    const patientEmail = encodeURIComponent(this.patientService.getEmail(call.patient) || '');
    const patientAge = encodeURIComponent(call.patient.age || '');
    const patientName = encodeURIComponent(call.patient.name);
    const externalPatientFile = encodeURIComponent(call.patient.id);
    const callId = encodeURIComponent(call.id);
    const hospitalId = environment.PRESCRYPTO.HOSPITAL_ID;

    return `${environment.PRESCRYPTO.URL}/new/api_token/?v2_redirect=true&token=${prescryptoToken}&diagnosis=${diagnosis}&patient_email=${patientEmail}&patient_dob=${patientAge}&patient_name=${patientName}&call_id=${callId}&hospital=${hospitalId}&external_patient_file=${externalPatientFile}`;
  }
}
